<template>
    <div class="history-root now-warning-root">

      <div class="head seacrch-head">
        <span class="filter"><em>即时告警</em> 筛选</span>

        <span class="now-warning--condition">
          <button :class="{'query': true, 'active': item.selected}" @click="switchCondition(index)" v-for="(item, index) in condition" :key="index">{{item.text}}</button>
        </span>
      </div>
        <div class="table-wrap clearfix" v-loading="realtimeWarningListLoading" element-loading-text="加载中" style="margin-bottom:140px">
          <!-- <base-empty-data v-if="realtimeLists.length == 0" style="margin-top:20px;"></base-empty-data> -->
            <el-table
              :data="realtimeLists"
              stripe
              :row-style="tableRowStyle"
              :header-cell-style="headerCellStyle"
              :max-height = 620
              style="width: 100%;">

            <el-table-column
              fixed
              label="序号"
              width="60"  align="center"
              type="index"
              :index="indexMethod">
            </el-table-column>
                <el-table-column
                        width="180" align="center"
                        label="报警时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | dateFormat}}</span>
                    </template>
                </el-table-column>

              <el-table-column
                fixed
                width="160"  align="center"
                prop="device.deviceId"
                label="设备ID">
                <template slot-scope="scope">
                  <span>{{scope.row.device.deviceId}}{{scope.row.device.deviceNoDefined}}</span>
                </template>
              </el-table-column>
              <el-table-column
                width="240"  align="center"
                label="单位名称">
                  <template slot-scope="scope" v-if="scope.row.area != null">
                      <span v-if="scope.row.area.child == 2">{{scope.row.area.parentName}}</span>
                      <span v-if="scope.row.area.child == 0">{{scope.row.area.areaName}}</span>
                  </template>
              </el-table-column>
                <el-table-column
                        width="240"  align="center"
                        prop="device.name"
                        label="设备名称">
                </el-table-column>
              <el-table-column
                width="180"  align="center"
                label="配电箱名称">
                  <template slot-scope="scope" v-if="scope.row.area != null">
                      <span v-if="scope.row.area.child == 2">{{scope.row.area.areaName}}</span>
                      <span v-if="scope.row.area.child == 0"></span>
                  </template>
              </el-table-column>
                <el-table-column
                        width="240"  align="center"
                        prop="device.location"
                        label="安装位置">
                </el-table-column>

               <el-table-column
                prop="lineType"  align="center"  width="100"
                label="设备类型">
                <template slot-scope="scope">
                <span v-if="scope.row.device.deviceType == 1">火灾设备</span>
                <span v-if="scope.row.device.deviceType == 2">空开设备</span>
                <span v-if="scope.row.device.deviceType == 3">烟感设备</span>
                <span v-if="scope.row.device.deviceType == 4">可燃气设备</span>

                </template>
              </el-table-column>

              <el-table-column
                prop="loopType"  align="center"  width="100"
                label="报警类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.loopType == 1">过欠压</span>
                  <span v-if="scope.row.loopType == 2">过载</span>
                  <span v-if="scope.row.loopType == 3">超温</span>
                  <span v-if="scope.row.loopType == 4">漏电</span>
                  <span v-if="scope.row.loopType == 5">烟雾</span>
                  <span v-if="scope.row.loopType == 6">可燃气浓度</span>
                  <span v-if="scope.row.loopType == 7">烟感</span>
                  <span v-if="scope.row.loopType == 8">电弧</span>
                  <span v-if="scope.row.loopType == 9">联动</span>
                </template>
              </el-table-column>

              <el-table-column
                prop="alarmType"  align="center" width="100"
                label="报警名称">
              </el-table-column>

              <el-table-column prop="currentValue"  align="center" label="报警数值">
                <template slot-scope="scope">
                  <span v-if="scope.row.loopType == 1">{{scope.row.currentValue}}V</span>
                  <span v-if="scope.row.loopType == 2">{{scope.row.currentValue}}A</span>
                  <span v-if="scope.row.loopType == 3">{{scope.row.currentValue}}℃</span>
                  <span v-if="scope.row.loopType == 4">{{scope.row.currentValue}}mA</span>
                  <span v-if="scope.row.loopType == 5">{{scope.row.currentValue}}</span>
                  <span v-if="scope.row.loopType == 6">{{scope.row.currentValue}}LEL</span>
                  <span v-if="scope.row.loopType == 7">{{scope.row.currentValue}}</span>
                  <span v-if="scope.row.loopType == 8">{{scope.row.currentValue}}mA</span>
                  <span v-if="scope.row.loopType == 8">{{scope.row.currentValue}}</span>

                </template>
              </el-table-column>
              <!-- <el-table-column
                prop="rectificationStatus"
                label="整改状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.rectificationStatus == 0" style="color: red">未处理</span>
                  <span v-if="scope.row.rectificationStatus == 1">已处理</span>
                </template>
              </el-table-column> -->
              <el-table-column
                prop="handleStatus"
                width="120"
                label="预处理状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.handleStatus == 0" style="color: red">未处理</span>
                  <span v-if="scope.row.handleStatus == 1">已处理</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                width="180"
                prop="warningHandle.ideaContent"
                label="处理意见">
              </el-table-column> -->
              <el-table-column
                fixed="right"
                width="240"  align="center"
                label="操作">
                <template slot-scope="scope">
                  <button class="detail2" @click="devince(scope.row.device.deviceType,scope.row.deviceId,scope.row.area.areaCode,scope.row.createTime)">查看</button>
                  <button class="detail" @click="handleCurrentWarning(scope.row)">预处理</button>
                  <!-- <button  class="detail2"  @click="handleSingleWarningYu(scope.row)">现场整改</button>  -->
                </template>
              </el-table-column>

            </el-table>
        </div>
          <div>
            <base-pagination
                            v-if="pageData.totalPage > 0"
                            :current_page="pageData.pageNum"
                            :total_page="pageData.total"
                            :per_page="pageData.totalPage"
                            @paginate="fetchPage"/>
          </div>


      <transition name="el-fade-in">
        <span v-if="dialogWarningVisible">
          <div class="mask" ref="mask"></div>
          <div class="dialog-warning-wrap">
            <h1 class="title">告警信息处理</h1>
            <textarea v-model="content" placeholder="请输入处理意见"></textarea>
            <p class="button-group">
              <button @click="dialogWarningVisible = false">取消</button>
              <button  class="confirm" @click="submitContent">确定</button>
            </p>
          </div>
        </span>
      </transition>
      <transition name="el-fade-in">
        <span  v-if="dialogWarningYu">
          <div class="mask" ref="mask"></div>
          <div class="dialog-warning-wrap">
            <h1 class="title">现场整改处理</h1>
            <textarea v-model="content" placeholder="请输入处理意见"></textarea>
            <p class="button-group">
              <button @click="dialogWarningYu = false">取消</button>
              <button  class="confirm" @click="handleSingleWarningToRequestYu">确定</button>
            </p>
          </div>
        </span>
      </transition>
          <!-- <el-dialog
      title="现场整改"
      :visible.sync="dialogWarningYu"
      v-if="dialogWarningYu"
      width="48%" >
      <div class="dialog-warning">
        <textarea v-model="content" placeholder="请输入处理意见"></textarea>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogWarningYu = false">取 消</el-button>
        <el-button type="primary"  @click="handleSingleWarningToRequestYu">确 定</el-button>
      </span>
    </el-dialog> -->
    </div>
</template>

<script>
    import common from '@/common/config'
    export default {
        data(){
          return {
            start: '',
            end: '',
            options: [
              {
                value: '1',
                label: '最近1天'
              }, {
                value: '2',
                label: '最近3天'
              }, {
                value: '3',
                label: '最近5天'
              }, {
                value: '4',
                label: '最近一周'
              }, {
                value: '5',
                label: '最近一月'
              }
            ],
            value: '',
            zindex: 0,
            content: '',
            dialogWarningVisible: false,
            dialogWarningYu:false,
            condition: common.warningLogListFilterType.map( (item, index) => {
              return {
                selected: index == 0,
                text: item.label,
                value: item.value
              }
            }),
            type: '',
            pageData: {
              current_page: 1,
              total: 1,
              per_page: 1
            },
            realtimeWarningListLoading: false,
            selectedWarning: null,
            realtimeList: [],
          }
        },
        mounted(){
          this.zindex = 1000000;

          this.getRealtimeWarningList();
        },
        computed: {
          realtimeLists: {
            get(){
              return this.$store.state.realtimeWarningList;
            }
          }
        },
        methods: {
          tableRowStyle({row,rowIndex}){
            return 'text-align:center'
          },
          headerCellStyle({ row, column, rowIndex, columnIndex }){
          if (rowIndex === 0) {
            return 'text-align:center;color:#606266'
            }
          },
          indexMethod(index){
            // return index+1
             return (this.pageData.pageNum-1) * this.pageData.pageSize + index + 1
          },
          handleCurrentWarning( item, index ){
            this.dialogWarningVisible = true;
            this.selectedWarning = item;
            this.selectedWarning.index = index;
          },
          // handleSingleWarningYu( item,index ){
          //   this.dialogWarningYu = true;
          //   this.selectedWarning = item;
          //   this.selectedWarning.index = index;
          // },
          fetchPage(page){
            this.pageData.current_page= page;
            this.getRealtimeWarningList()
          },
          getRealtimeWarningList(){
            this.realtimeWarningListLoading = true;
            this.$store.dispatch('getAlarmList', {
              loopType: this.type,
              pageNum: this.pageData.current_page || 1,
              pageSize: 12
            }).then(res => {
              this.realtimeWarningListLoading = false;
              this.pageData = res;
              this.realtimeList = res.data.reverse();
              if(res.data.length == 0){
                return;
              }
              this.$store.commit('clearRealtime')
              this.$store.commit('updateOutComponentLoading', false)
              this.realtimeList.forEach( item => {
                this.$store.commit('submitRealtimeWarning', item)
              })
            }).catch(() => {
              this.realtimeWarningListLoading = false;
            });

          },
            devince(deviceType,deviceId,id,createTime){

            this.$store.commit("creatTime", createTime)
            if(deviceType == 1){
              window.open("/#/warning_detail/" + deviceType + "/" + deviceId + "/" + id + "/" + createTime + "?a=2", "newwindow", "height=700, width=1400, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no")
              }else if(deviceType ==3){
              window.open ("/#/smok_detail/"+ deviceType + "/" + deviceId + "/" + id + "?a=2", "newwindow", "height=700, width=1400, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no")
              }else if(deviceType ==4){
              window.open ("/#/combWaring_detail/"+ deviceType + "/" + deviceId + "/" + id + "?a=2", "newwindow", "height=700, width=1400, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no")
              }
            // console.log(deviceType)
      },
          submitContent(){
            if(this.content == ''){
              this.$r('请填写处理意见')
              return;
            }
            this.$http.post('api/alarm/idea', {
              id: this.selectedWarning.id,
              uuid:this.selectedWarning.uuid,
              ideaContent: this.content,
              handleStatus:1
            }).then( res => {
              this.$s('提交成功')
              this.content = ''
              this.dialogWarningVisible = false;
              this.getRealtimeWarningList()
            }).catch(error => {
              this.dialogWarningVisible = false;
              this.$e(error.msg)
            })

          },
          // handleSingleWarningToRequestYu(){
          //   this.$http.post('api/alarmHandle/add1', {
          //     id: this.selectedWarning.id,
          //     uuid:this.selectedWarning.uuid,
          //     handleContent: this.content,
          //     rectificationStatus:1
          //   }).then( res => {
          //     this.$message({type: 'success', message: '处理成功'})
          //     this.content = ''
          //     this.dialogWarningYu = false;
          //     this.getRealtimeWarningList()
          //   }).catch( error => {
          //     this.dialogWarningVisible = false;
          //     this.$e(error.msg)
          //   })
          // },
          switchCondition( index ){
            this.$store.commit('clearRealtime')
            this.condition.forEach( item => item.selected = false);
            this.condition[index].selected = true;
            this.type = this.condition[index].value
            this.getRealtimeWarningList();
          },
          pageCallback( page ){

          }
        },
    }
</script>
<style lang="scss" scoped>
  .history-root{
    padding:0;
    margin: 10px 20px;
    margin-left: 40px;
  }
  .warning-table tr{
    transition: background .3s linear;
  }
  .warning-table tr:hover{
    background: #cccccc;
    color: #333;
  }
  // .warning-table tr:last-child{
  //   background: #f0f3fb;
  // }
  // .warning-table tr:last-child:hover{
  //   background: #f0f3fb;
  // }
  .dialog-warning-wrap{
    position: fixed;
    background: white;
    margin: auto;
    z-index: 100;
    left:0;
    top:50px;
    right:0;
    bottom:0;
    width: 900px;
    height: 350px;
    .title{
      text-align:center;
      font-size: 12px;
      line-height: 63px;
      font-weight: normal;
      color:#000;
    }
    textarea{
      width: 819px;
      margin: 0 auto;
      display: block;
      height: 200px;
      resize: none;
      padding: 10px;
      border: 1px solid #cccccc;
    }
    .button-group{
      text-align: right;
      padding-right: 31px;
      padding-top:10px;
      button{
        width:90px;
        height: 33px;
        line-height: 33px;
        border-radius: 4px;
        color: #3498db;
      }
      button.confirm{
        background: #3498db;
        color: white;
      }
    }
  }
  .now-warning-root{
    .seacrch-head{
      .filter{
        width: 130px;
        font-size: 12px;
        em{
          display: inline-block;
          width: 87px;
          font-size: 14px;
        }
      }
      .now-warning--condition{
        button.active{
          background: #ffb607;
        }
        .query{
          // background: #cccccc;
        }
      }
    }
  }
  .detail2{
  	display:block;
	width: 68px;
    height: 26px;
    display: inline-block;
    text-align: center;
    line-height: 26px;
    border: 1px solid #41c8f4;
    background:none;
    color: #41c8f4;
    /*border: none;*/
    border-radius: 4px;
  }
</style>




// WEBPACK FOOTER //
// src/component/base-realtimewarning.vue